import { render, staticRenderFns } from "./Mobile-Index.vue?vue&type=template&id=7dc798d7&scoped=true&"
import script from "./Mobile-Index.vue?vue&type=script&lang=js&"
export * from "./Mobile-Index.vue?vue&type=script&lang=js&"
import style0 from "./Mobile-Index.vue?vue&type=style&index=0&id=7dc798d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc798d7",
  null
  
)

export default component.exports